<template>
    <div class="relative inline-block text-left">
        <button
            @click="open = !open"
            type="button"
            class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
                ></path>
            </svg>
            <SlideOver size="xxxl" :show="open" @close="open = false">
                <slot>
                    <Tabs>
                        <template v-if="gamificationSet">
                            <Tab :title="$t('messages.reinforcements_positive')" :selected="true">
                                <GiveRewardCurrencyPointsForm
                                    :students="student"
                                    :rewards="gamificationSet.rewards.filter((r) => !r.is_negative)"
                                    @close="open = false"
                                />
                            </Tab>
                            <Tab :title="$t('messages.reinforcements_negative')">
                                <GiveRewardCurrencyPointsForm
                                    :students="student"
                                    :rewards="gamificationSet.rewards.filter((r) => r.is_negative)"
                                    @close="open = false"
                                />
                            </Tab>
                        </template>
                        <Tab :title="$t('messages.reinforcements_free')">
                            <GiveDirectCurrencyPointsForm :students="student" @close="open = false" />
                        </Tab>
                        <Tab :title="$tc('messages.gamification_items', 2)" v-if="items">
                            <GiveItemsForm :students="student" :items="items" @close="open = false" />
                        </Tab>
                    </Tabs>
                </slot>
            </SlideOver>
        </button>
    </div>
</template>

<script>
import GiveDirectCurrencyPointsForm from '@/components/Gamification/GiveDirectCurrencyPointsForm.vue';
import GiveRewardCurrencyPointsForm from '@/components/Gamification/GiveRewardCurrencyPointsForm.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import GiveItemsForm from '@/components/Gamification/GiveItemsForm.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    emits: ['close'],
    components: {
        SlideOver,
        GiveDirectCurrencyPointsForm,
        GiveRewardCurrencyPointsForm,
        GiveItemsForm,
        Tabs,
        Tab,
    },

    name: 'GiveCurrencyActionsPanel',

    props: {
        student: {
            required: true,
        },
        gamificationSet: {
            required: false,
            type: Object,
        },
        items: {
            required: false,
            type: Array,
        },
    },

    data() {
        return {
            open: false,
        };
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
    },
};
</script>
